// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root___KBQo","ranges":"BmiRanges_ranges__3p4hh"};